import script from "./DashboardArea.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardArea.vue?vue&type=script&setup=true&lang=js"

import "./DashboardArea.vue?vue&type=style&index=0&id=d6372530&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6372530"]])

export default __exports__